import { Chart } from 'chart.js';
import { customTooltipCallback } from '../tooltip';
import { ActivityComparisonChartSettings } from './types';

export function setupActivityComparisonChart(
  chartContext: HTMLCanvasElement,
  chartSettings: ActivityComparisonChartSettings
) {
  const data = chartSettings.dataSet.data;
  new Chart(chartContext, {
    type: 'bar',
    data: {
      labels: data.map((x) => x.label),
      datasets: [
        {
          label: 'hodnoty',
          data: data.map((x) => x.abundanceNormalized),
          backgroundColor: [
            '#9E7BF4',
            '#F95959',
            '#FFEC6F',
            '#C4F27D',
            '#5168FF',
            '#D3D3D3',
          ],
          barPercentage: 0.6,
          categoryPercentage: 1,
          order: 2,
        },
        {
          label: 'average',
          type: 'scatter',
          data: data.map((a, i) => ({ y: i, x: a.averageNormalized })) as any,
          borderColor: '#000',
          backgroundColor: '#000',
          pointBorderColor: '#000',
          pointBackgroundColor: '#000',
          pointHoverBackgroundColor: '#000',
          pointHoverBorderColor: '#000',
          order: 1,
          pointBorderWidth: 3,
        },
      ],
    },
    options: {
      plugins: {
        tooltip: {
          enabled: false,
          external: (context) =>
            customTooltipCallback(context, (tooltip) => {
              const dataEntry = data[tooltip.dataIndex];

              if (tooltip.datasetIndex === 0) {
                return dataEntry.abundance.toLocaleString();
              }
              if (tooltip.datasetIndex === 1) {
                return (
                  Math.round(dataEntry.average * 100) / 100
                ).toLocaleString();
              }
            }),
        },
        legend: {
          display: false,
        },
      },
      indexAxis: 'y',
      scales: {
        x: {
          type: 'linear',
          beginAtZero: true,
          max: 1,
          ticks: {
            display: false,
            count: 6,
          },
          grid: {
            drawBorder: false,
            color: '#E4E5E7',
          },
        },
        y: {
          grid: {
            display: false,
          },
        },
      },
    },
  });
}
